import React, { useMemo } from 'react';
import { InvestorProfileContext } from './context';
import { useFormData } from './hooks/useFormData';
import { useQuestionnaire } from './hooks/useQuestionnaire';

type InvestorProfileOptions = {
    clientId?: number;
    productId?: number;
    sessionStorageKey: string;
};

type InvestorProfileProviderProps = {
    options: InvestorProfileOptions;
    children: React.ReactNode;
};

export const InvestorProfileProvider = ({
    options,
    children,
}: InvestorProfileProviderProps) => {
    const {
        clientId,
        sessionStorageKey,
    } = options;

    const questionnaire = useQuestionnaire({ clientId });
    const formData = useFormData({
        serverData: questionnaire?.data,
        sessionStorageKey,
    });
    const getValue = (callback: (value: any) => any) => callback({
        clientId,
        questionnaire,
        formData,
    });

    const state = useMemo(() => (
        {
            clientId,
            questionnaire,
            formData,
            getValue,
        }
    ), [
        clientId,
        questionnaire,
        formData,
        getValue,
    ]);

    return (
        <InvestorProfileContext.Provider
            value={state}
        >
            {children}
        </InvestorProfileContext.Provider>
    );
};
